import React from 'react';
import PropTypes from 'prop-types';

const Alert = props => {
  const className = `alert alert-${props.class}`;
  return (
    <div className={className} role="alert">
      {props.message}
    </div>
  );
};

Alert.propTypes = {
  message: PropTypes.string
};

Alert.defaultProps = {
  class: 'danger',
  message: 'Sorry, an error occurred.'
};

export default Alert;



// WEBPACK FOOTER //
// ./src/modules/misc/components/Alert.js